import { createContext, useContext } from "react";

export const FooterContext = createContext();

export const useFooter = () => useContext(FooterContext);